// extracted by mini-css-extract-plugin
module.exports = {"sidebarItem":"style_sidebarItem__3Rz0M","mobile":"style_mobile__3vD1V","menuItemTitle":"style_menuItemTitle__3dulS"};